import axios from "axios";

const baseURL = "http://localhost:3001";

const api = axios.create({
  baseURL, // change to your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
